import { apiCall } from './gqlClient';

const GETPUBLICVIDEOS_QUERY = `
  query getPublicVideos($providerId: Int, $keyword: String, $webIntegrationId: Int) {
    getPublicVideos(providerId: $providerId, keyword: $keyword, webIntegrationId: $webIntegrationId)
    {
      id
			tempProductId
			providerId
			svcTypeId
			prodGroupId
			name
			description
			price
			orderIndex
			active
			archive
			target
			imageUrl
			fileType
			categoryName
			duration
			durationType
			alwaysAvailable
			progress
      ...fragments
    }
  }`;

export const getPublicVideosApiCall = async ({providerId, keyword, webIntegrationId}, fragments = null) => apiCall({ query: GETPUBLICVIDEOS_QUERY, variables: {providerId, keyword, webIntegrationId}, fragments });

const GETUSERVIDEOS_QUERY = `
  query getUserVideos($userId: Int!) {
    getUserVideos(userId: $userId)
    {
      id
			tempProductId
			providerId
			svcTypeId
			prodGroupId
			name
			description
			price
			orderIndex
			active
			archive
			target
			imageUrl
			fileType
			categoryName
			duration
			durationType
			alwaysAvailable
			progress
      ...fragments
    }
  }`;

export const getUserVideosApiCall = async ({userId}, fragments = null) => apiCall({ query: GETUSERVIDEOS_QUERY, variables: {userId}, fragments });

const GETBOUGHTVIDEOS_QUERY = `
  query getBoughtVideos($videoId: String) {
    getBoughtVideos(videoId: $videoId)
    {
      id
			tempProductId
			providerId
			svcTypeId
			prodGroupId
			name
			description
			price
			orderIndex
			active
			archive
			target
			imageUrl
			fileType
			categoryName
			duration
			durationType
			alwaysAvailable
			progress
      ...fragments
    }
  }`;

export const getBoughtVideosApiCall = async ({videoId}, fragments = null) => apiCall({ query: GETBOUGHTVIDEOS_QUERY, variables: {videoId}, fragments });

const GETMYVIDEOS_QUERY = `
  query getMyVideos($providerId: Int, $keyword: String) {
    getMyVideos(providerId: $providerId, keyword: $keyword)
    {
      id
			tempProductId
			providerId
			svcTypeId
			prodGroupId
			name
			description
			price
			orderIndex
			active
			archive
			target
			imageUrl
			fileType
			categoryName
			duration
			durationType
			alwaysAvailable
			progress
      ...fragments
    }
  }`;

export const getMyVideosApiCall = async ({providerId, keyword}, fragments = null) => apiCall({ query: GETMYVIDEOS_QUERY, variables: {providerId, keyword}, fragments });

const GETVIDEOS_QUERY = `
  query getVideos {
    getVideos
    {
      id
			tempProductId
			providerId
			svcTypeId
			prodGroupId
			name
			description
			price
			orderIndex
			active
			archive
			target
			imageUrl
			fileType
			categoryName
			duration
			durationType
			alwaysAvailable
			progress
      ...fragments
    }
  }`;

export const getVideosApiCall = async (fragments = null) => apiCall({ query: GETVIDEOS_QUERY, variables: {}, fragments });

const GETALLNOTACQUIREDUSERVIDEOS_QUERY = `
  query getAllNotAcquiredUserVideos($userId: Int!) {
    getAllNotAcquiredUserVideos(userId: $userId)
    {
      id
			tempProductId
			providerId
			svcTypeId
			prodGroupId
			name
			description
			price
			orderIndex
			active
			archive
			target
			imageUrl
			fileType
			categoryName
			duration
			durationType
			alwaysAvailable
			progress
      ...fragments
    }
  }`;

export const getAllNotAcquiredUserVideosApiCall = async ({userId}, fragments = null) => apiCall({ query: GETALLNOTACQUIREDUSERVIDEOS_QUERY, variables: {userId}, fragments });

const GETARCHIVEDVIDEOS_QUERY = `
  query getArchivedVideos {
    getArchivedVideos
    {
      id
			tempProductId
			providerId
			svcTypeId
			prodGroupId
			name
			description
			price
			orderIndex
			active
			archive
			target
			imageUrl
			fileType
			categoryName
			duration
			durationType
			alwaysAvailable
			progress
      ...fragments
    }
  }`;

export const getArchivedVideosApiCall = async (fragments = null) => apiCall({ query: GETARCHIVEDVIDEOS_QUERY, variables: {}, fragments });

const GETALLVIDEOS_QUERY = `
  query getAllVideos {
    getAllVideos
    {
      id
			tempProductId
			providerId
			svcTypeId
			prodGroupId
			name
			description
			price
			orderIndex
			active
			archive
			target
			imageUrl
			fileType
			categoryName
			duration
			durationType
			alwaysAvailable
			progress
      ...fragments
    }
  }`;

export const getAllVideosApiCall = async (fragments = null) => apiCall({ query: GETALLVIDEOS_QUERY, variables: {}, fragments });

const GETVIDEOCOURSESYOUFEEL_QUERY = `
  query getVideoCoursesYouFeel {
    getVideoCoursesYouFeel
  }`;

export const getVideoCoursesYouFeelApiCall = async () => apiCall({ query: GETVIDEOCOURSESYOUFEEL_QUERY, variables: {}});

const GETUSERVIDEOCOURSESYOUFEEL_QUERY = `
  query getUserVideoCoursesYouFeel {
    getUserVideoCoursesYouFeel
  }`;

export const getUserVideoCoursesYouFeelApiCall = async () => apiCall({ query: GETUSERVIDEOCOURSESYOUFEEL_QUERY, variables: {}});

const GETVIDEOCOURSEFILESYOUFEEL_QUERY = `
  query getVideoCourseFilesYouFeel($id: String!) {
    getVideoCourseFilesYouFeel(id: $id)
  }`;

export const getVideoCourseFilesYouFeelApiCall = async ({id}, ) => apiCall({ query: GETVIDEOCOURSEFILESYOUFEEL_QUERY, variables: {id}});

const GETUSERVIDEOCOURSEFILESYOUFEEL_QUERY = `
  query getUserVideoCourseFilesYouFeel($id: String!) {
    getUserVideoCourseFilesYouFeel(id: $id)
  }`;

export const getUserVideoCourseFilesYouFeelApiCall = async ({id}, ) => apiCall({ query: GETUSERVIDEOCOURSEFILESYOUFEEL_QUERY, variables: {id}});

const ADDVIDEOTOUSER_QUERY = `
  mutation addVideoToUser($productId: String!, $userId: Int!, $email: String, $startTime: DateTime, $endTime: DateTime, $price: Float, $paid: Float, $isPaid: Boolean, $method: String, $channel: String) {
    addVideoToUser(productId: $productId, userId: $userId, email: $email, startTime: $startTime, endTime: $endTime, price: $price, paid: $paid, isPaid: $isPaid, method: $method, channel: $channel)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const addVideoToUserApiCall = async ({productId, userId, email, startTime, endTime, price, paid, isPaid, method, channel}, fragments = null) => apiCall({ query: ADDVIDEOTOUSER_QUERY, variables: {productId, userId, email, startTime, endTime, price, paid, isPaid, method, channel}, fragments });

const ADDVIDEOTOGROUPOFUSERS_QUERY = `
  mutation addVideoToGroupOfUsers($productId: String!, $groupId: Int!, $startTime: DateTime, $endTime: DateTime, $price: Float, $paid: Float, $isPaid: Boolean, $method: String, $channel: String) {
    addVideoToGroupOfUsers(productId: $productId, groupId: $groupId, startTime: $startTime, endTime: $endTime, price: $price, paid: $paid, isPaid: $isPaid, method: $method, channel: $channel)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const addVideoToGroupOfUsersApiCall = async ({productId, groupId, startTime, endTime, price, paid, isPaid, method, channel}, fragments = null) => apiCall({ query: ADDVIDEOTOGROUPOFUSERS_QUERY, variables: {productId, groupId, startTime, endTime, price, paid, isPaid, method, channel}, fragments });

const SAVEVIDEO_QUERY = `
  mutation saveVideo($request: ProductInput!) {
    saveVideo(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const saveVideoApiCall = async ({request}, fragments = null) => apiCall({ query: SAVEVIDEO_QUERY, variables: {request}, fragments });

const ARCHIVEVIDEO_QUERY = `
  mutation archiveVideo($id: String!) {
    archiveVideo(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const archiveVideoApiCall = async ({id}, fragments = null) => apiCall({ query: ARCHIVEVIDEO_QUERY, variables: {id}, fragments });

const TOGGLEVIDEOSTATUS_QUERY = `
  mutation toggleVideoStatus($id: String!, $isPublished: Boolean!) {
    toggleVideoStatus(id: $id, isPublished: $isPublished)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const toggleVideoStatusApiCall = async ({id, isPublished}, fragments = null) => apiCall({ query: TOGGLEVIDEOSTATUS_QUERY, variables: {id, isPublished}, fragments });

const TOGGLEVIDEOORDERSTATUS_QUERY = `
  mutation toggleVideoOrderStatus($id: Int!, $active: Boolean!) {
    toggleVideoOrderStatus(id: $id, active: $active)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const toggleVideoOrderStatusApiCall = async ({id, active}, fragments = null) => apiCall({ query: TOGGLEVIDEOORDERSTATUS_QUERY, variables: {id, active}, fragments });

const RESTOREVIDEO_QUERY = `
  mutation restoreVideo($id: String!) {
    restoreVideo(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const restoreVideoApiCall = async ({id}, fragments = null) => apiCall({ query: RESTOREVIDEO_QUERY, variables: {id}, fragments });

const REORDERVIDEOS_QUERY = `
  mutation reorderVideos($oldPosition: Int!, $newPosition: Int!) {
    reorderVideos(oldPosition: $oldPosition, newPosition: $newPosition)
  }`;

export const reorderVideosApiCall = async ({oldPosition, newPosition}, ) => apiCall({ query: REORDERVIDEOS_QUERY, variables: {oldPosition, newPosition}});

const DUPLICATEPRODUCT_QUERY = `
  mutation duplicateProduct($id: String!) {
    duplicateProduct(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const duplicateProductApiCall = async ({id}, fragments = null) => apiCall({ query: DUPLICATEPRODUCT_QUERY, variables: {id}, fragments });

const CHANGEUSERVIDEOSTARTENDTIME_QUERY = `
  mutation changeUserVideoStartEndTime($id: Int!, $startTime: DateTime!, $endTime: DateTime!) {
    changeUserVideoStartEndTime(id: $id, startTime: $startTime, endTime: $endTime)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const changeUserVideoStartEndTimeApiCall = async ({id, startTime, endTime}, fragments = null) => apiCall({ query: CHANGEUSERVIDEOSTARTENDTIME_QUERY, variables: {id, startTime, endTime}, fragments });
